import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Collapse from "@mui/material/Collapse";
import { useSharedSelector } from "../../store/SharedProvider";
import { selectCloudHasUnsyncedChanges } from "../../store/app-configurations/app-configurations-selectors";
import CustomAlert from "../Feedback/CustomAlert";
import ForceSyncButton from "../Websockets/ForceSyncButton";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()((theme) => ({
  tab: {
    "& .MuiBox-root": {
      [theme.breakpoints.down("lg")]: {
        padding: "0px",
        paddingTop: theme.spacing(0.5),
      },
    },
    height: `calc(100% - ${theme.mixins.toolbar.minHeight as number}px - 4px)`,
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: theme.spacing(1.3),
    },
    "&::-webkit-scrollbar-track": {
      borderLeft: `${theme.spacing(0.5)} solid rgba(0, 0, 0, 0)`,
      backgroundClip: "padding-box",
      backgroundColor: theme.palette.grey[100],
    },
    "&::-webkit-scrollbar-thumb": {
      borderLeft: `${theme.spacing(0.5)} solid rgba(0, 0, 0, 0)`,
      backgroundClip: "padding-box",
      backgroundColor: theme.palette.grey[300],
    },
  },
}));

interface TabPanelProps extends BoxProps {
  index: any;
  value: any;
  noPadding?: boolean;
  showSphereUnsyncedChanges?: boolean;
}

const TabPanel: React.FC<TabPanelProps> = ({
  index,
  value,
  children,
  noPadding,
  showSphereUnsyncedChanges,
  ...props
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const sphereHasUnsyncedChanges = useSharedSelector((state) => selectCloudHasUnsyncedChanges(state));

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={classes.tab}
      {...props}
    >
      {value === index && (
        <Box
          p={noPadding ? 0 : 1}
          sx={{
            pt: noPadding ? "0!important" : undefined, // Ensure padding top is 0 if noPadding is true
          }}
        >
          {showSphereUnsyncedChanges && (
            <Collapse in={sphereHasUnsyncedChanges}>
              <CustomAlert
                sx={{ mb: 2 }}
                severity="info"
                header={t("info-sphere-has-unsynced-changes")}
                action={<ForceSyncButton />}
              />
            </Collapse>
          )}
          {children}
        </Box>
      )}
    </Box>
  );
};

export const TabPanelA11yProps = (index: any) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export default TabPanel;
